import { useEffect, useState } from "react"
import { BankAccountInfoTab } from "../BankAccountInfoTab"
import { IKYCData, KYCInitialState, KYCWalletBody } from "../interface/kyc"
import { useQuery } from "@tanstack/react-query"
import { COMPANY_ENDPOINTS, companyService } from "services/companyService"
import { LoadingIndicatorWhite } from "components/custom/LoaderWhite"
import { BvnTab } from "../BvnTab"

const BankAccountInfo = ({
  redirectUrl,
  onSuccess,
}: {
  redirectUrl?: string
  onSuccess?: () => void
}) => {
  const [activeKey, setActiveKey] = useState<string[]>(["1"])
  const [userInfo, setUserInfo] = useState<KYCWalletBody>(KYCInitialState)

  const { isLoading: isGetKYCLoading, data: kycRes } = useQuery<
    IBaseRes<IKYCData>
  >({
    queryKey: [COMPANY_ENDPOINTS.VIEW_SETTINGS, "verify"],
    queryFn: () => companyService.viewSettings("verify"),
    refetchOnWindowFocus: false,
    cacheTime: 24 * 60 * 60 * 1000,
  })
  const kyc = kycRes?.data
  useEffect(() => {
    if (kyc) {
      setUserInfo({
        ...userInfo,
        phone: kyc?.verification?.phone || "",
        bank_code: kyc?.verification?.bank_code || "",
        currency_id: String(kyc?.verification?.currency_id) || "",
        bank_country_code: kyc?.verification?.bank_country_code || "",
        account_number: kyc?.verification?.account_number || "",
      })
    }
  }, [kyc])
  const handleUpdateKYCInfo = (body: KYCWalletBody) => {}

  return (
    <div className="">
      {isGetKYCLoading ? (
        <div className="h-screen flex justify-center  items-center">
          <LoadingIndicatorWhite />
        </div>
      ) : (
        kyc?.verification && (
          <div className="max-w-[1024px] mt-6  rounded-md space-y-[20px]">
            <BankAccountInfoTab
              setActiveKey={setActiveKey}
              isActive={activeKey.includes("1")}
              setUserInfo={setUserInfo}
              userInfo={userInfo}
            />
            {userInfo?.bank_country_code === "NG" && (
              <BvnTab
                setActiveKey={setActiveKey}
                isActive={activeKey.includes("2")}
                setUserInfo={setUserInfo}
                userInfo={userInfo}
                onSuccess={onSuccess}
              />
            )}
          </div>
        )
      )}
    </div>
  )
}

export default BankAccountInfo
